import { datadogLogs } from '@datadog/browser-logs';
import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import App from './App';
import awsConf, { awsApiAuthorization } from './aws-exports';
import { environment } from './environments/environment';
import './index.css';
import { initRum } from './rum';
import { discardError } from './utils/apiErrorResponse';

initRum();

Amplify.configure(awsConf, awsApiAuthorization);

datadogLogs.onReady(() => {
  if (environment.datadogClientToken) {
    datadogLogs.init({
      clientToken: environment.datadogClientToken,
      site: environment.datadogSite,
      service: environment.datadogService,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      env: environment.datadogEnv,
      beforeSend: (log) => {
        return !discardError(log);
      },
    });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>,
);
